/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Add_Font_ButtonInputs */



/**
* | output |
* | --- |
* | "Add Font" |
*
* @param {Options_Fonts_Add_Font_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_add_font_button = /** @type {((inputs?: Options_Fonts_Add_Font_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Add_Font_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter la police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftart hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить шрифт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加字体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar fonte")
	return /** @type {LocalizedString} */ ("Add Font")
});